import React, { Component } from "react";

import Radio from "semantic-ui-react/dist/es/addons/Radio";
import Checkbox from "semantic-ui-react/dist/es/modules/Checkbox";
import { Icon, Popup } from "semantic-ui-react";
import { ReactComponent as InfoIcon } from "../../../../assets/svg/info-icon.svg";
import { getActivityOptions } from "../../../SettingsContainer/UserActivity/utils/userActivityLogsUtils";

class FilterRefine extends Component {
    state = {};

    getSentimentOptions() {
        return [
            { key: "ALL", value: "all", text: "All" },
            { key: "POS", value: "positive", text: "Positive" },
            { key: "NEG", value: "negative", text: "Negative" },
            { key: "NEU", value: "neutral", text: "Neutral" },
        ];
    }

    getPriorityOptions = () => {
        return [
            { key: "all", text: "All", value: "selectAll" },
            // { key: "rr", text: "Highest", value: "HIGHEST" },
            { key: "rr", text: "High", value: "HIGH" },
            { key: "mrr", text: "Medium", value: "MEDIUM" },
            { key: "drr", text: "Low", value: "LOW" },
        ];
    };

    getStatusOptions = () => {
        let listData = [];
        // console.log("ddfddffd", this.props.statusListData);
        this.props.statusListData?.status_groups?.map((ele) => {
            listData.push({
                key: `${ele.status}`,
                text: `${ele.status}`,
                value: `${ele.status}`,
                group: `${ele.status}`,
            });
        });

        if (listData.length > 0) {
            listData.unshift({ key: "all", text: "All", value: "selectAll", group: "selectAll" });
        }

        return listData;

        // return [
        //     { key: "all", text: "All", value: "selectAll" },
        //     { key: "unassigned", text: "Unassigned", value: "UNASSIGNED" },
        //     { key: "new", text: "New", value: "NEW" },
        //     { key: "open", text: "Open", value: "OPEN" },
        //     { key: "progress", text: "Progress", value: "PROGRESS" },
        //     // { key: "on_hold", text: "On Hold", value: "ON_HOLD" },
        //     { key: "CW", text: "Closed", value: "CLOSED" },
        //     { key: "invalid", text: "Invalid", value: "INVALID" },
        // ];
    };

    getMessgaeOptions = () => {
        return [
            { key: "all", text: "All", value: "selectAll" },
            // { key: "posts", text: "Posts", value: "POST" },
            { key: "comments", text: "Comments", value: "COMMENT" },
            { key: "dm", text: "Private Message", value: "DM" },
        ];
    };
    getStarPrint = (val) => {
        return (
            <span key={val} className="rating-count-row">
                {/* <div> */}
                {Array(val)
                    .fill(0)
                    .map((element, index) => {
                        return <Icon name="star" key={index + val} />;
                    })}
                {/* </div> */}
            </span>
        );
    };

    getRatingsOptions = () => {
        return [
            { key: "all", text: "All", value: "selectAll" },
            // { key: "posts", text: "Posts", value: "POST" },
            { key: "one", text: this.getStarPrint(1), value: 1 },
            { key: "two", text: this.getStarPrint(2), value: 2 },
            { key: "three", text: this.getStarPrint(3), value: 3 },
            { key: "four", text: this.getStarPrint(4), value: 4 },
            { key: "five", text: this.getStarPrint(5), value: 5 },
        ];
    };

    getKeywordSyncOptions = () => {
        let result = [];
        if (!this.props.smrKeywords) return result;
        if (this.props.smrKeywords.length > 0) {
            result = this.props.smrKeywords.map((ele, ind) => {
                //  console.log("ddsfdsfdsfdsfdsf", this.props.currentUser?.roles, this.props.smrTags[ele]);
                let values = {};

                values["key"] = ele.id;
                values["text"] = ele.name;
                values["value"] = ele.id;
                // }
                return values;
            });
        }
        result.sort((a, b) => {
            if (a.text.toLowerCase() < b.text.toLowerCase()) return -1;
            if (a.text.toLowerCase() > b.text.toLowerCase()) return 1;
            return 0;
        });
        const allData = { key: "all", text: "All", value: "selectAll" };
        result.unshift(allData);
        return result;
    };
    getTagsOptions = () => {
        let result = [];
        if (!this.props.smrTags) return result;
        if (Object.keys(this.props.smrTags)?.length > 0) {
            result = Object.keys(this.props.smrTags).map((ele, ind) => {
                //  console.log("ddsfdsfdsfdsfdsf", this.props.currentUser?.roles, this.props.smrTags[ele]);
                let values = {};
                // if (
                //     this.props.currentUser?.roles?.includes("cxm") ||
                //     (this.props.currentUser?.roles?.includes("cxa") && this.props.smrTags[ele].sync_in_smr == 1)
                // ) {
                values["key"] = ele;
                values["text"] = ele;
                values["value"] = ele;
                // }
                return values;
            });
        }
        result = result.filter((ele) => Object.keys(ele).length > 0);

        let allData = { key: "all", text: "All", value: "selectAll" };
        let Uncategorized = { key: "Uncategorized", text: "Uncategorized", value: "Uncategorized" };
        if (Object.keys(this.props.smrTags).length > 0) {
            result.push(Uncategorized);
        } else {
            //result.push(allData);
            result.push(Uncategorized);
        }

        result.sort((a, b) => {
            if (a.text.toLowerCase() < b.text.toLowerCase()) return -1;
            if (a.text.toLowerCase() > b.text.toLowerCase()) return 1;
            return 0;
        });

        result.unshift(allData);

        // console.log("result", result);

        return result;
    };

    getExclusionOptions() {
        return [
            { key: "yes", value: "yes", text: "Apply" },
            { key: "no", value: "no", text: "Do Not Apply" },
        ];
    }

    getSalesforceOptions = () => {
        return [
            { key: "all", text: "All", value: "selectAll" },
            // { key: "posts", text: "Posts", value: "POST" },
            { key: "synced", text: "Synced", value: "sync_done" },
            { key: "nonsynced", text: "Not Synced", value: "Non Synced" },
        ];
    };

    getSpamOptions() {
        return [
            { key: "0", value: "0", text: "All messages" },
            { key: "1", value: "1", text: "Excluded messages" },
        ];
    }

    getUsersOptions() {
        let result = [];
        if (!this.props.userLists) return result;
        const users = this.props.userLists?.sort((a, b) =>
            a.name.toLowerCase() < b.name.toLowerCase() ? -1 : a.name.toLowerCase() > b.name.toLowerCase() ? 1 : 0,
        );

        result.push({ key: "all", text: "All", value: "selectAll" });
        users?.forEach((user) => {
            result.push({
                key: user.username,
                text: user.name,
                value: user.lite_id,
            });
        });
        return result;
    }

    renderRefiningSelector() {
        // console.log("sdfdsfsdsfsdf", this.props.smrTags)

        if (!this.props.filterRefineFilter) return;
        const messageTypeOptions = this.getMessgaeOptions();
        const statusTypeOptions = this.getStatusOptions();
        const sentimentOptions = this.getSentimentOptions();
        const priortyOptions = this.getPriorityOptions();
        const exclusionOptions = this.getExclusionOptions();
        const tagsOptions = this.getTagsOptions();
        const sfOptions = this.getSalesforceOptions();
        const ratingOptions = this.getRatingsOptions();
        const spamOptions = this.getSpamOptions();
        const userOptions = this.getUsersOptions();
        const activityOptions = getActivityOptions();
        const keywordSyncOptions = this.getKeywordSyncOptions();

        return (
            <>
                {this.props.renderItems.includes("sentiment") &&
                    this.getInlineDropdownCheckbox({
                        text: "Sentiment",
                        options: sentimentOptions,
                        clickFunction: (val) => this.handleSentimentChange(val),
                        value: this.props.filterRefineFilter.sentiment,
                    })}
                {this.props.renderItems.includes("messageType") &&
                    this.getInlineDropdownCheckbox({
                        text: "Message Type",
                        options: messageTypeOptions,
                        clickFunction: (val) => this.handlemessageTypeChange(val),
                        value: this.props.filterRefineFilter.messageTypeOption,
                        info: true,
                    })}
                {this.props.renderItems.includes("smrKeywords") &&
                    this.getInlineDropdownCheckbox({
                        text: "Keyword Based Rules",
                        options: keywordSyncOptions,
                        clickFunction: (val) => this.handleKeywordTypeChange(val),
                        value: this.props.filterRefineFilter.keywordOption,
                    })}

                {this.props.renderItems.includes("ratings") &&
                    this.getInlineDropdownCheckbox({
                        text: "Ratings",
                        options: ratingOptions,
                        clickFunction: (val) => this.handleRatingsChange(val),
                        value: this.props.filterRefineFilter.ratingsOption,
                        info: "ratings",
                    })}
                {this.props.renderItems.includes("ticketStatus") &&
                    this.getInlineDropdownCheckbox({
                        text: "Ticket Status",
                        options: statusTypeOptions,
                        clickFunction: (val) => this.handlestatusTypeChange(val),
                        value: this.props.filterRefineFilter.statusOption,
                        group: this.props.statusGroup,
                    })}

                {this.props.renderItems.includes("sfStatus") &&
                    this.props.ConfigurationList?.data?.configs?.[0]?.salesforce_integration_enabled == 1 &&
                    this.getInlineDropdown({
                        text: "Salesforce Status",
                        options: sfOptions,
                        clickFunction: (val) => this.handleSalesforceStatusChange(val),
                        value: this.props.filterRefineFilter.sfOption,
                        // group: this.props.statusGroup,
                    })}

                {this.props.renderItems.includes("tags") &&
                    this.getInlineDropdownCheckbox({
                        text: "Ticket Tags",
                        options: tagsOptions,
                        clickFunction: (val) => this.handletagsTypeChange(val),
                        value: this.props.filterRefineFilter.tagsOption,
                    })}

                {this.props.renderItems.includes("ticketPriority") &&
                    this.getInlineDropdownCheckbox({
                        text: "Ticket Priority",
                        options: priortyOptions,
                        clickFunction: (val) => this.handlePriorityTypeChange(val),
                        value: this.props.filterRefineFilter.priorityOption,
                    })}
                {this.props.renderItems.includes("exclusion") &&
                    this.getInlineDropdown({
                        text: "Exclusions",
                        options: exclusionOptions,
                        clickFunction: (val) => this.handleExclusionChange(val),
                        value: this.props.filterRefineFilter.exclusion,
                    })}

                {this.props.renderItems.includes("spam_filter") &&
                    this.getInlineDropdown({
                        text: "Spam Filter",
                        options: spamOptions,
                        clickFunction: (val) => this.handleSpamChange(val),
                        value: this.props.filterRefineFilter.spamOptions,
                    })}
                {this.props.renderItems.includes("activityTypes") &&
                    this.getInlineDropdownCheckbox({
                        text: "Activity Type",
                        options: activityOptions,
                        clickFunction: (val) => this.handleActivityChange(val, activityOptions.length || 0),
                        value: this.props.filterRefineFilter.activityTypes,
                    })}
                {this.props.renderItems.includes("users") &&
                    this.getInlineDropdownCheckbox({
                        text: "Users",
                        options: userOptions,
                        clickFunction: (val) => this.handleUserChange(val),
                        value: this.props.filterRefineFilter.users,
                    })}
            </>
        );
    }

    getInlineDropdownCheckbox({ text, options, clickFunction, value, group, info }) {
        // console.log("first", text, options, clickFunction, value, group);
        // console.log("lkjhgf", text, options, clickFunction, value, group);
        return (
            <div className="filter-type">
                <div className="filter-type-header">
                    <div className="filter-type-header-left">
                        <span className="filter-type-name">{text}</span>
                        {info ? (
                            <Popup
                                inverted
                                className=" skiptranslate"
                                size="tiny"
                                position="bottom right"
                                content={
                                    info === "ratings"
                                        ? "Ratings for Google Play Store, App Store and Google Business reviews."
                                        : "The ticket will be shown based on the first message type."
                                }
                                trigger={<InfoIcon className="durationInfo-icon" />}
                                style={{ zIndex: 9999999, backgroundColor: "#112C5A", width: "600px" }}
                            />
                        ) : (
                            <></>
                        )}
                    </div>
                </div>
                <div className="filter-list-items">
                    {options.map((o) => (
                        <div className={`filter-list-item  ${text === "Ratings" ? "justify__start" : ""}`} key={o.key}>
                            {/* <Checkbox checked={value?.includes(o.value)} onClick={() => clickFunction(o.value)} label={o.text} /> */}

                            <Checkbox
                                checked={group ? value?.includes(o.group) : value?.includes(o.value)}
                                onClick={group ? () => clickFunction(o.group) : () => clickFunction(o.value)}
                                label={text !== "Ratings" ? o.text : ""}
                            />
                            {text === "Ratings" ? (
                                <div className="individual__ratings" onClick={() => clickFunction(o.value)}>
                                    {o.text}
                                </div>
                            ) : null}
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    getInlineDropdown({ text, options, clickFunction, value }) {
        // console.log("first",text, options, clickFunction, value)
        return (
            <div className="filter-type">
                <div className="filter-type-header">
                    <div className="filter-type-header-left">
                        <span className="filter-type-name">{text}</span>
                    </div>
                </div>
                <div className="filter-list-items">
                    {options.map((o) => (
                        <div className="filter-list-item" key={o.key}>
                            <Radio checked={o.value === value} onClick={() => clickFunction(o.value)} label={o.text} />
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    handleSentimentChange = (val) => {
        let sentiment = this.props.filterRefineFilter.sentiment;
        if (val === "all") {
            sentiment = ["all"];
        } else {
            if (sentiment[0] === "all") sentiment = [val];
            else if (sentiment.includes(val)) sentiment = sentiment.filter((v) => v !== val);
            else sentiment.push(val);
        }
        if (sentiment.length === 3 || sentiment.length === 0) sentiment = ["all"];
        this.props.updateRefineFilter({ ...this.props.filterRefineFilter, sentiment });
    };

    handlestatusTypeChange = (val) => {
        //  console.log("statusvvvv", val, this.props.filterRefineFilter.statusOption, this.props.statusGroup);
        let statusOption = this.props.filterRefineFilter.statusOption;
        if (val === "selectAll") {
            statusOption = ["selectAll"];
        } else {
            if (statusOption[0] === "selectAll") statusOption = [val];
            // else if (this.props.statusGroup){let data= this.props.statusListData?.statuses?.filter((ele) => ele.status==);}
            else if (statusOption.includes(val)) statusOption = statusOption.filter((v) => v !== val);
            else statusOption.push(val);
        }
        if (statusOption.length === this.props.statusListData?.status_groups?.length || statusOption.length === 0) statusOption = ["selectAll"];
        this.props.updateRefineFilter({ ...this.props.filterRefineFilter, statusOption });
    };

    handleKeywordTypeChange = (val) => {
        let keywordOption = this.props.filterRefineFilter.keywordOption;
        if (val === "selectAll") {
            if (keywordOption.includes("selectAll")) keywordOption = [];
            else keywordOption = ["selectAll"];
        } else {
            if (keywordOption[0] === "selectAll") keywordOption = [val];
            else if (keywordOption.includes(val)) keywordOption = keywordOption.filter((v) => v !== val);
            else keywordOption.push(val);
        }
        if (keywordOption.length === this.props.smrKeywords?.length) keywordOption = ["selectAll"];
        this.props.updateRefineFilter({ ...this.props.filterRefineFilter, keywordOption });
    };

    handletagsTypeChange = (val) => {
        let tagsOption = this.props.filterRefineFilter.tagsOption;
        if (val === "selectAll") {
            tagsOption = ["selectAll"];
        } else {
            if (tagsOption[0] === "selectAll") tagsOption = [val];
            else if (tagsOption.includes(val)) tagsOption = tagsOption.filter((v) => v !== val);
            else tagsOption.push(val);
        }
        // if (tagsOption.length === 1 && Object.keys(this.props.smrTags).length === 0) tagsOption = ["Uncategorized"];
        if (tagsOption.length === Object.keys(this.props.smrTags).length + 1 || tagsOption.length === 0) tagsOption = ["selectAll"];
        this.props.updateRefineFilter({ ...this.props.filterRefineFilter, tagsOption });
    };

    handleSalesforceStatusChange = (val) => {
        let sfOption = this.props.filterRefineFilter.sfOption;

        if (val === "selectAll") {
            sfOption = "selectAll";
        } else {
            if (sfOption === "selectAll") sfOption = val;
            // else if (sfOption.includes(val)) sfOption = sfOption.filter((v) => v !== val);
            // else sfOption.push(val);
            sfOption = val;
        }

        // if (sfOption.length === 2 || sfOption.length === 0) sfOption = ["selectAll"];
        this.props.updateRefineFilter({ ...this.props.filterRefineFilter, sfOption });
    };

    handlePriorityTypeChange = (val) => {
        let priorityOption = this.props.filterRefineFilter.priorityOption;
        if (val === "selectAll") {
            priorityOption = ["selectAll"];
        } else {
            if (priorityOption[0] === "selectAll") priorityOption = [val];
            else if (priorityOption.includes(val)) priorityOption = priorityOption.filter((v) => v !== val);
            else priorityOption.push(val);
        }
        if (priorityOption.length === 4 || priorityOption.length === 0) priorityOption = ["selectAll"];
        this.props.updateRefineFilter({ ...this.props.filterRefineFilter, priorityOption });
    };

    handlemessageTypeChange = (val) => {
        let messageTypeOption = this.props.filterRefineFilter.messageTypeOption;
        if (val === "selectAll") {
            messageTypeOption = ["selectAll"];
        } else {
            if (messageTypeOption[0] === "selectAll") messageTypeOption = [val];
            else if (messageTypeOption.includes(val)) messageTypeOption = messageTypeOption.filter((v) => v !== val);
            else messageTypeOption.push(val);
        }
        if (messageTypeOption.length === 2 || messageTypeOption.length === 0) messageTypeOption = ["selectAll"];
        this.props.updateRefineFilter({ ...this.props.filterRefineFilter, messageTypeOption });
    };

    handleRatingsChange = (val) => {
        let ratingsOption = this.props.filterRefineFilter.ratingsOption;
        if (val === "selectAll") {
            ratingsOption = ["selectAll"];
        } else {
            if (ratingsOption[0] === "selectAll") ratingsOption = [val];
            else if (ratingsOption.includes(val)) ratingsOption = ratingsOption.filter((v) => v !== val);
            else ratingsOption.push(val);
        }
        if (ratingsOption.length === 5 || ratingsOption.length === 0) ratingsOption = ["selectAll"];
        this.props.updateRefineFilter({ ...this.props.filterRefineFilter, ratingsOption });
    };

    handleExclusionChange = (exclusion) => {
        this.props.updateRefineFilter({ ...this.props.filterRefineFilter, exclusion });
    };

    handleSpamChange = (spamOptions) => {
        this.props.updateRefineFilter({ ...this.props.filterRefineFilter, spamOptions });
    };

    handleUserChange = (val) => {
        let users = this.props.filterRefineFilter.users;
        if (val === "selectAll") {
            users = ["selectAll"];
        } else {
            if (users[0] === "selectAll") users = [val];
            else if (users.includes(val)) users = users.filter((v) => v !== val);
            else users.push(val);
        }
        if (users.length === this.props.userLists?.length || users.length === 0) users = ["selectAll"];
        this.props.updateRefineFilter({ ...this.props.filterRefineFilter, users });
    };

    handleActivityChange = (val, total) => {
        let activityTypes = this.props.filterRefineFilter.activityTypes;
        if (val === "selectAll") {
            activityTypes = ["selectAll"];
        } else {
            if (activityTypes[0] === "selectAll") activityTypes = [val];
            else if (activityTypes.includes(val)) activityTypes = activityTypes.filter((v) => v !== val);
            else activityTypes.push(val);
        }
        if (activityTypes.length === total - 1 || activityTypes.length === 0) activityTypes = ["selectAll"];
        this.props.updateRefineFilter({ ...this.props.filterRefineFilter, activityTypes });
    };

    render() {
        return this.renderRefiningSelector();
    }
}

export default FilterRefine;
